import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import { Helmet, HelmetProvider } from "react-helmet-async";
import AdblockModal from 'components/adsense/AdblockModal/AdblockModal';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import SimcContainer from 'containers/calc/SimcContainer';

const SimcPage = () => {  

  const itemName = useSelector(state => {
    const currSelWeapon = state.items?.toJS?.().currSelWeapon;
    return currSelWeapon?.currItem?.ITEM_NM ?? '아이템';
  });

  return (
    <PageTemplate>
      <AdblockModal/>
        <HelmetProvider>
          <Helmet>
            <title>{`이터널시티 ${itemName} 데미지 계산 · 사냥 시뮬레이션 | 이터인포`}</title>
            <meta
              name="description"
              content="이터널시티 아이템과 무기 데이터를 기반으로 일반·크리티컬·헤드샷·발화 데미지를 계산하고, 현재 스탯과 스킬 세팅으로 실제 사냥 효율을 시뮬레이션해볼 수 있는 정보 페이지입니다."
            />
          </Helmet>
        </HelmetProvider>

        <SimcContainer />
    </PageTemplate>
  );
};

export default SimcPage;